// extracted by mini-css-extract-plugin
export default {"legend":"Legend_legend__GDYFG","legend_total":"Legend_legend_total__Rfkzr","legend_util":"Legend_legend_util__EzMAy","legend_active":"Legend_legend_active__fllDT"};